export default "__VITE_ASSET__Bs8DMq9K__"